import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const fetchDepartments = async () => {
  try {
    const res = await request(API_ROUTES.getDepartment, { method: "GET" });

    if (!res.ok) throw new Error("Error en la petición de departamentos");

    const data = await res.json();

    return data.data;
  } catch (err) {
    console.error("Error cargando departamentos:", err);
    return [];
  }
};

export const fetchTowns = async (departmentId) => {
  try {
    const res = await request(API_ROUTES.getTown(departmentId), {
      method: "GET",
    });

    if (!res.ok) throw new Error("Error en la petición de municipios");
    
    const data = await res.json();

    return data.data;
  } catch (err) {
    console.error("Error cargando municipios:", err);
    return [];
  }
};
